export const SUPPORTED_IMAGE_TYPES = ['image/png', 'image/jpg', 'image/jpeg'];
export const SUPPORTED_VIDEO_TYPES = ['video/mp4'];

export const SUPPORTED_MIME_TYPES = SUPPORTED_IMAGE_TYPES.concat(
  SUPPORTED_VIDEO_TYPES
);
